var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 180.26",
    style: {
      enableBackground: "new 0 0 612 180.26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D2DEEA;}\n\t.st1{fill:#5E9BC1;}\n\t.st2{fill:#85AECD;}\n\t.st3{fill:#ABC5DB;}\n\t.st4{fill:#06749C;}\n\t.st5{fill:#154C5E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 90.11,
    cy: 13.67,
    r: 9.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 89.96,
    cy: 49.45,
    r: 14.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 60.55,
    cy: 38.88,
    r: 8.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 62.68,
    cy: 15.66,
    r: 6.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 148.36,
    cy: 62.28,
    r: 8.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 104.78,
    cy: 109.48,
    r: 7.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 76.26,
    cy: 77.4,
    r: 9.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 27.74,
    cy: 80.22,
    r: 9.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 113.64,
    cy: 14.82,
    r: 6.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 120.63,
    cy: 38.49,
    r: 9.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 135.89,
    cy: 24.45,
    r: 5.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 42.19,
    cy: 24.94,
    r: 4.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 30.99,
    cy: 46.07,
    r: 11.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.19,150.45c0.2,1.39,0.21,2.82,0.02,4.3c-0.77,5.75-5.26,10.48-10.49,12.96 c-9.15,4.34-20.95,2.66-27.8-4.99c-5.99-6.68-7.91-16.28-7.61-25.02c0.1-2.78,0.42-5.55,1.02-8.27 c3.23-14.82,13.55-27.23,26.14-35.14c4.15-2.61,8.55-4.79,12.63-7.51c1.74-1.16,3.48-2.48,4.44-4.35 c0.96-1.87,0.92-4.41-0.62-5.83c-1.66-1.53-4.27-1.22-6.38-0.44c-9.35,3.44-14.77,13.15-24.67,15.57 c-2.94,0.72-6.16,0.7-8.88-0.64c-3.56-1.76-5.77-5.57-6.61-9.47c-1.23-5.73,0.31-11.52-0.88-17.26c-0.35-1.67-0.93-3.35-2.11-4.57 s-3.05-1.88-4.62-1.25c-2.06,0.84-2.79,3.43-2.71,5.67c0.08,2.19,0.15,4.36,0.21,6.53c0.59,24.13-5.78,48.2,2.52,71.66 c3.46,9.79,8.23,19.52,17.44,25.04c9.14,5.48,20.92,6.69,30.89,2.8c9.52-3.71,15.86-12.09,18.89-21.65 c2.03-6.41,2.71-13.15,2.99-19.84c0.28-6.59,0.58-13.12,0.27-19.72c-0.17-3.5-0.46-6.99-0.9-10.47c-0.3-2.42-0.17-6.88-2.88-8.08 c-3.85-1.7-5.14,4.03-5.21,6.64c-0.14,5.64,1.4,11.26,0.55,16.9c-0.4,2.68-1.44,5.41-3.57,7.09c-4.78,3.76-11.93,1.91-16.73-0.67 c-3.96-2.12-7.45-5.3-11.71-6.78c-0.8-0.28-1.66-0.49-2.5-0.36c-0.84,0.14-1.66,0.7-1.88,1.52c-0.19,0.7,0.08,1.43,0.39,2.09 c2.66,5.59,8.84,8.7,13.6,12.22C102.2,134.18,110.92,141.47,112.19,150.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M174.22,87.57c-0.09-8.02-1.31-16.02-3.61-23.73c-1.88-6.29-4.46-12.61-8.45-17.89 c-2.82-3.74-5.53-8.14-9.46-10.81c-5.67-3.84-9.26,1.07-5.22,6.56c3.04,4.14,6.97,7.54,10.13,11.58 c3.17,4.04,5.62,9.08,4.93,14.18c-0.27,2-1.04,3.97-2.37,5.48c-2.73,3.1-7.4,3.83-11.4,2.86c-10.38-2.5-16.22-11.66-23.54-18.55 c-1.03-0.97-2.14-1.92-3.48-2.39c-2.19-0.77-4.63,0.26-5.38,2.53c-1.5,4.5,4,8.45,6.81,11.11c9.18,8.73,17.94,18.42,22.59,30.25 c6.72,17.1,4.04,38-8.51,51.67c-12.31,13.4-29.56,20.22-47.57,20.22c-10.85,0-21.69-2.33-31.32-7.45 c-15.91-8.45-31.31-25.76-28.79-44.99c0.89-6.78,3.84-13.41,8.88-18.12c2.32-2.17,5.24-3.69,7.66-5.78 c1.29-1.12,2.63-2.65,2.22-4.3c-0.38-1.52-2.17-2.32-3.73-2.16s-2.94,1.02-4.3,1.8c-2.45,1.4-5.02,2.61-7.66,3.6 c-3.29,1.23-6.9,2.13-10.28,1.19c-3.88-1.09-6.81-4.55-7.93-8.42c-1.12-3.87-0.63-8.06,0.66-11.87c1.29-3.82,3.33-7.32,5.35-10.8 c0.78-1.34,1.58-2.97,0.9-4.37c-0.63-1.3-2.37-1.76-3.76-1.34c-1.39,0.41-2.47,1.48-3.41,2.59c-5.97,7.04-7.91,16.67-8.13,25.9 c-0.02,0.79-0.02,1.58-0.02,2.38C6.01,88.47,6,88.45,6,88.45c0,46.46,37.67,84.13,84.13,84.13c12.2,0,24.34-2.65,35.41-7.79 c10.73-4.98,20.36-12.25,28.12-21.18c7.81-8.98,13.68-19.61,17.09-31.02C173.17,104.47,174.32,96.01,174.22,87.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M249.56,82.78h-0.34l-12.7,25.4h-5.46l-12.7-25.4h-0.34v35.2h-10.14V58.31h8.27l17.47,34.35h0.34l17.56-34.35 h8.18v59.67h-10.14L249.56,82.78L249.56,82.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M270.29,88.4c0-11.25,5.8-18.24,17.9-18.24c12.36,0,17.65,6.73,17.65,18.24v9.72h-25.32v4.6 c0,3.58,2.21,7.08,8.44,7.08c5.37,0,8.01-1.19,12.45-3.58l3.41,7.59c-4.77,2.73-9.12,4.86-16.28,4.86 c-12.19,0-18.24-6.39-18.24-16.88V88.4H270.29z M280.52,90.11h15.34c0-7.42-1.45-11.08-7.67-11.08 C282.05,79.03,280.52,82.26,280.52,90.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M357.66,82.78h-0.34l-12.7,25.4h-5.46l-12.7-25.4h-0.34v35.2h-10.14V58.31h8.27l17.47,34.35h0.34l17.56-34.35 h8.18v59.67h-10.14L357.66,82.78L357.66,82.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M395.86,135.2h-9.72l5.54-17.22h-1.87L376,70.84h10.65l8.78,33.84h0.34l9.29-33.84h10.74L395.86,135.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M434.48,117.98h-10.74V58.31h33.33v9.38h-22.59v16.37h20.63v9.38h-20.63V117.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M465.25,100.51V88.57c0-11.34,5.88-18.41,18.33-18.41c12.53,0,18.33,6.99,18.33,18.41v11.93 c0,11.34-5.8,18.16-18.33,18.16C471.14,118.66,465.25,111.67,465.25,100.51z M475.48,89v10.91c0,6.56,2.05,9.72,8.1,9.72 c6.05,0,8.1-3.15,8.1-9.72V89c0-6.65-2.05-9.72-8.1-9.72S475.48,82.35,475.48,89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M511.46,54.05h10.23v63.93h-10.23V54.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M532.77,54.05H543V88.4h3.92l10.49-17.56h10.91l-13.04,21.4l13.38,25.74h-11.08c0,0-3.32-6.65-10.4-20.97H543 v20.97h-10.23V54.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M572.5,114.14l2.9-7.5c5.71,2.47,9.97,3.41,13.47,3.41c4.94,0,7.16-2.05,7.16-6.05 c0-8.78-22.42-4.18-22.42-20.2c0-9.38,6.9-13.64,16.28-13.64c5.71,0,10.91,1.62,15,4.18l-3.07,7.59 c-5.2-2.39-8.69-3.15-11.51-3.15c-4.09,0-6.82,1.19-6.82,4.69c0,7.59,22.5,4.09,22.5,19.69c0,10.06-5.11,15.51-17.13,15.51 C583.16,118.66,576.51,116.62,572.5,114.14z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full_logo.952421e436b0ab89cf2029fbb819c973.svg";
export { ForwardRef as ReactComponent };